module.exports = __webpack_public_path__ + "img/组 298.5d8814a3.png";